import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row p-1" }
const _hoisted_2 = { class: "w-full h-full" }
const _hoisted_3 = { class: "px-4 overflow-auto" }
const _hoisted_4 = { class: "table-auto w-full border-spacing-y-1 border-separate text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "N° de dividendo"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Rentabilidad Nominal"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Rentabilidad Real"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Monto UF"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Acumulado UF"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Monto CLP"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Acumulado CLP"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Estado"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-[16px]" }, "Cuenta destino")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "flex justify-center item, dinos-center" }, null, -1)
const _hoisted_7 = { class: "text-[16px] py-1 pr-8 lg:pr-0" }
const _hoisted_8 = { class: "text-[16px] py-1 pr-8 lg:pr-3 text-end" }
const _hoisted_9 = { class: "text-[16px] py-1 pr-8 lg:pr-3 text-end" }
const _hoisted_10 = { class: "text-[16px] py-1 pr-8 lg:pr-3 text-end" }
const _hoisted_11 = { class: "text-[16px] py-1 pr-8 lg:pr-3 text-end" }
const _hoisted_12 = { class: "text-[16px] py-1 pr-8 lg:pr-3 text-end" }
const _hoisted_13 = { class: "text-[16px] py-1 pr-8 lg:pr-3 text-end" }
const _hoisted_14 = { class: "text-[16px] py-1 pr-8 lg:pr-3 text-end" }
const _hoisted_15 = { class: "text-[16px] py-1 pr-8 lg:pr-0" }
const _hoisted_16 = { class: "text-[16px] py-1 pr-8 lg:pr-0" }
const _hoisted_17 = {
  key: 0,
  class: "w-full text-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "No existen dividendos para este accionista", -1)
const _hoisted_19 = [
  _hoisted_18
]

import { computed, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import {
  formatNumber,
  toBadgeFormat,
  toBadgeFormatUf,
} from "@/services/utils";

import { DividendService } from "@/services/dividends/dividendService";
import { DividendStatusType, PaymentStatus } from "@/services/dividends/types";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderDividendsTable',
  setup(__props) {

const router = useRouter();

const dividendService = new DividendService();
const dividends = ref<PaymentStatus[]>([]);
const shareholderId = computed(() =>
  Number(router.currentRoute.value.params.id)
);

async function getDividends() {
  let dividend = await dividendService.getShareholderDividends(
    shareholderId.value
  );
  if (!dividend.success) {
    console.log("Error al obtener los dividendos");
    return false;
  }
  dividends.value = dividend.data;
}
function getPrettyPrintStatus(status: DividendStatusType) {
  switch (status) {
    case DividendStatusType.PAID:
      return "Pagado";
    case DividendStatusType.PENDING:
      return "Pendiente";
    case DividendStatusType.REJECTED:
      return "Rechazado";
    default:
      break;
  }
  return status;
}

onMounted(() => {
  getDividends();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dividends.value, (dividend) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: dividend.id,
                class: "hover:bg-gray-100 cursor-pointer gap-5"
              }, [
                _hoisted_6,
                _createElementVNode("td", _hoisted_7, _toDisplayString(dividend.pendingDate
                    ? _unref(moment)(dividend.pendingDate).format("DD/MM/YYYY")
                    : " "), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(dividend.dividendCode ?? "-"), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(dividend.nominalProfitability
                    ? _unref(formatNumber)(dividend.nominalProfitability) + " %"
                    : ""), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(dividend.realProfitability
                    ? _unref(formatNumber)(dividend.realProfitability) + " %"
                    : " "), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(dividend.totalUf ? _unref(toBadgeFormatUf)(dividend.totalUf) : " "), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(dividend.dividendBalanceUf
                    ? _unref(toBadgeFormatUf)(dividend.dividendBalanceUf)
                    : " "), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(dividend.totalClp
                    ? "$ " + _unref(toBadgeFormat)(dividend.totalClp)
                    : " "), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(dividend.dividendBalanceClp
                    ? "$ " + _unref(toBadgeFormat)(dividend.dividendBalanceClp)
                    : " "), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(dividend.status ? getPrettyPrintStatus(dividend.status) : " "), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(dividend.accountNumber ? dividend.accountNumber : " "), 1)
              ]))
            }), 128))
          ])
        ]),
        (dividends.value && dividends.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})